import React, { useState, useEffect } from "react";
import { Modal, Button, Typography } from "antd";
import { patchWalletIssueApproved } from "../../../../services/walletIssue.service";
import { swalNotification } from "../../../alret/notificztion";
import { validationErrors } from "../../../../utils/Helpers";

const { Text } = Typography;
const ModalIssueApprove = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const handleCancel = () => {
    props.setvisible(false);
  };

  const onFinishIaaueReject = async () => {
    onFinishIaaueStatus("reject");
  };
  const onFinishIaaueApprove = async () => {
    onFinishIaaueStatus("approve");
  };
  const onFinishIaaueStatus = async (value) => {
    try {
      setMBtnLoading(true);
      const resp = await patchWalletIssueApproved(props.issueData.id, value);
      swalNotification(
        `Order issue ${value}`,
        `Issue ${value} has been change successfully`,
        "success"
      );
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }
  };
  return (
    <Modal
      title={"Approve Issue"}
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Cancel</Button>,
        <Button loading={MBtnLoading} onClick={onFinishIaaueReject}>
          Reject
        </Button>,
        <Button loading={MBtnLoading} onClick={onFinishIaaueApprove}>
          Approve
        </Button>,
      ]}
    >
      <Text>Are you sure?</Text>
    </Modal>
  );
};
export default ModalIssueApprove;
